import { Box, Grid, GridItem } from '@chakra-ui/react'
import React, { useState } from 'react'
import SideBar from "../components/SideBar";
import { Outlet } from "react-router-dom";
import NavBar from '../components/NavBar';
// import useResponsive from '../hook/useResponsive';


const AppLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [open, setOpen] = useState(false);


  return (
    <>
      <Grid 
        templateColumns={"repeat(6, 1fr)"} 
        overflowX="hidden"
        maxW="100vw"
        w="100%"
      >
        <GridItem
          position={{ base: "absolute", lg: "relative" }}
          minH={"100vh"}
          as={"aside"}
          // borderRight={"1px solid #505050"}
          colSpan={{ base: 6, lg: 1 }}
          // bg={"#0C0C0C"}
          w={{
            base: sidebarOpen ? "100%" : "0%",
            md: sidebarOpen ? "80%" : "0%",
            lg: "inherit",
          }}
          maxW={{
            base: sidebarOpen ? "100%" : "0%",
            md: sidebarOpen ? "80%" : "0%",
            lg: "inherit",
          }}
          overflowX="hidden"
          zIndex={2}
          onClick={() => setOpen(false)}
        >
           <SideBar setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
        </GridItem>

        <GridItem
        //   minH={"100vh"}
          height="100vh"
          overflowY={"scroll"}
          overflowX={"hidden"}
          as={"main"}
          colSpan={{ base: 6, lg: 5 }}
          maxW="100vw"
        //   px={{ base: "16px", md: "22px", lg: "39px" }}
          // border={"2px solid red"}
        //   ml={{base: 0, lg: calWidth}}
        >
          <Box>
            <NavBar
              pic={""}
              setSidebarOpen={setSidebarOpen}
              sidebarOpen={sidebarOpen}
              open={open}
              setOpen={setOpen}
            />
           
          </Box>
          <Box py={"2em"} w={"100%"} maxW="100%" overflowX="hidden" onClick={() => setOpen(false)}><Outlet /></Box>
        </GridItem>

      </Grid>
    </>
  );
}

export default AppLayout